export default {
  data() {
    return {
      timerId: null,
      form: {
        amount: '',
      },
      revenue: 0,
      dailyRevenue: 0,
      extraRevenue: 0,
      extraDailyRevenue: 0,
      selectedCoupon: {},
    }
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
    hasSelectCoupon() {
      return this.selectedCoupon && !!Object.keys(this.selectedCoupon).length
    },
  },
  methods: {
    delayExcute(delay, fn) {
      if (this.timerId) {
        clearTimeout(this.timerId)
      }
      this.timerId = setTimeout(() => {
        fn()
        this.timerId = null
      }, delay)
    },
    async getRevenue() {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      try {
        const params = {
          amount: Number(this.form.amount),
          interestPercent: this.currentProduct.interestPercent,
          term: this.currentProduct.term,
          extraAmount: Number(this.hasSelectCoupon ? this.selectedCoupon.rebate : ''),
          extraInterestPercent: Number(this.hasSelectCoupon ? this.selectedCoupon.percentage : ''),
        }
        const response = await this.$http.get('/investment/revenue', { params })
        const data = response.data.data
        this.revenue = data ? data.revenue : 0
        this.dailyRevenue = data ? data.revenueOfOneDay : 0
        this.extraRevenue = data ? data.extraRevenue : 0
        this.extraDailyRevenue = data ? data.extraRevenueOfOneDay : 0
      } catch (error) {
        console.log(error)
      }
    },
  },
  watch: {
    currentProduct(newVal, oldVal) {
      this.selectedCoupon = {}
      this.extraRevenue = 0
      if (newVal && newVal.type === 'FIXED_TRIAL') {
        this.form.amount = ''
      }
      if (!!this.form.amount || (newVal && newVal.type === 'FIXED_TRIAL')) {
        this.getRevenue()
      }
    },
  },
}
